import every from 'lodash/every';
import isEmpty from 'lodash/isEmpty';
import mapKeys from 'lodash/mapKeys';
import get from 'lodash/get';
import map from 'lodash/map';
import split from 'lodash/split';

export const validateEmptyContents = (contents) => every(contents, isEmpty);

export const transformKey = (key) => split(key, '.').join('_');

export const transformContentsForCustomPage = (contents) => mapKeys(contents, (_, key) => transformKey(key));

export const parseHeaderMenuItem = (contents, item) => {
  const { key, ...itemSettings } = item;
  const { configurations = {}, customPageId, ...itemContent } = get(contents, key, {});

  return {
    ...configurations,
    ...itemSettings,
    ...itemContent,
    key,
    contentId: itemContent.id,
    hidden: !itemContent.visible,
    children: map(get(item, 'children', []), (childItem) => parseHeaderMenuItem(contents, childItem)),
  };
};
